export const API_END_POINTS = {
  SETTINGS: {
    HIERARCHY: 'api/settings/v1/orgUnit/hierarchy',
    USER_DETAILS: 'api/settings/v1/orgUnit/list-with-user-details'
  },
  AUTHZ3: {
    HIERARCHY: 'api/platform/pfapi/api/businessHierarchy/v2',
    WORKSPACES: 'api/platform/pfapi/api/workspaces',
  },
  EINVOICE: {
    SUMMARY: 'api/einvv2/v1/einvoices/report/summary',
    METADATA: 'api/einvv2/v1/einvoices/report/metadata',
    INVOICES: 'api/einvv2/v1/einvoices/summary',
    PRINT: 'api/einvv2/v1/einvoices/print',
  },
  ANALYTICS:{
    FUNNEL_METRICS: 'api/funnelmetrics/funnelmetrics/einvcompanion',
  }
};
